import { observer } from 'mobx-react-lite';
import RoundedButton from '../../Globle/RoundedButton';
import {
    DimensionIcon,
    FitScreenIcon,
    MappingIcon,
    SnappingIcon,
} from '../../Globle/Icon';
import PageHandler from './PageHandler';
import { Collapse, Divider } from 'antd';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import UnitsMapping from './UnitsMapping';
import ClosetsMapping from './ClosetsMapping';
import { useState } from 'react';
import { ButtonMode } from '../../../config';
import { useMainContext } from '../../../hooks/useMainContext';
import CustomTooltip from '../../Globle/CustomTooltip';
import ScaleInput from '../../Header/ScaleInput';
import PageList from './PageList';

const Mapping = observer(() => {
    const { viewManager, closetManager, drawingManager, matrixManager } =
        useMainContext();
    const [activeKeys, setActiveKeys] = useState(ButtonMode.Unit);
    const isDisabled = !viewManager.doUserHasAccess();

    const buttons = [
        {
            tooltip: 'Fit to Screen',
            onClick: async () => {
                await closetManager.fitToScreen();
                await closetManager.fitToScreen();
            },
            icon: <FitScreenIcon />,
            isActive: false,
        },
        {
            tooltip: 'Show Snap Points',
            onClick: () => {
                const showSnapPoints = !closetManager.showSnapPoints;
                closetManager.setShowSnapPoints(showSnapPoints);
                if (showSnapPoints) {
                    closetManager.drawSnapPoints();
                } else {
                    closetManager.drawNewClosets();
                }
                matrixManager.setShowSnapPoints(showSnapPoints);
            },
            icon: <SnappingIcon />,
            isActive: closetManager.showSnapPoints,
        },
        {
            tooltip: 'Show Dimensions',
            onClick: () => {
                const showDistanceLabel = !closetManager.distanceLabel;
                closetManager.setDistanceLabel(showDistanceLabel);
                closetManager.drawNewClosets();
            },
            icon: <DimensionIcon />,
            isActive: closetManager.distanceLabel,
        },
    ];

    const expandIcon = ({ isActive }) => (
        <div className="cursor-pointer">
            {isActive ? (
                <IoIosArrowUp size={20} className="text-theme-black" />
            ) : (
                <IoIosArrowDown size={20} className="text-theme-black" />
            )}
        </div>
    );
    const items = [
        {
            children: <UnitsMapping />,
            key: ButtonMode.Unit,
            label: 'Units',
            className: 'custom-collapse-item !py-[16px]',
        },
        {
            children: <ClosetsMapping />,
            key: ButtonMode.Closet,
            label: 'Closets',
            className: 'custom-collapse-item !pt-[16px]',
        },
    ];
    const onChange = (key) => {
        if (isDisabled) return;
        setActiveKeys(key);
        const normalizedKey = Array.isArray(key) ? key[0] : key;
        if (!normalizedKey) return;
        viewManager.setButtonMode(normalizedKey);
        closetManager.setEditMode();
        if (drawingManager.isDrawingModeOn) {
            drawingManager.setDrawingMode(false);
            drawingManager.stopDrawing();
        }
        if (drawingManager.isRectangleModeOn) {
            drawingManager.setRectangleMode(false);
        }
        closetManager.setDistanceLabel(true);
        closetManager.drawNewClosets();
    };
    return (
        <div className=" mt-[16px] w-full z-10 mapping-container">
            <div className="flex items-center gap-[8px] justify-between ">
                <PageList />
                <PageHandler />
            </div>

            <Divider className="!mt-[16px] !mb-[16px]  !border-theme-border" />
            <div className="flex items-center gap-[8px]">
                {buttons.map((button, index) => (
                    <CustomTooltip
                        key={index}
                        label={button.tooltip}
                        placement="top"
                        styles={{
                            background: '#000000',
                            padding: '5px 8px',
                            fontSize: '12px',
                            color: '#fff',
                            lineHeight: '14px',
                        }}>
                        <RoundedButton
                            key={index}
                            {...button}
                            className="w-[48px] h-[48px]  mapping-icon-button"
                        />
                    </CustomTooltip>
                ))}
            </div>
            <Divider className="!mt-[16px] !mb-[16px]  !border-theme-border" />
            <ScaleInput />
            <Divider className="!mt-[16px] !mb-[0px]  !border-theme-border" />
            <Collapse
                bordered={false}
                rootClassName="custom-collapse"
                expandIcon={(panelProps) =>
                    expandIcon(
                        {
                            isActive: panelProps.isActive,
                        } || {},
                    )
                }
                accordion={true}
                expandIconPosition="end"
                collapsible="header"
                items={items}
                activeKey={activeKeys}
                onChange={onChange}
            />
        </div>
    );
});

export default Mapping;
